// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-fetch';
import type { ListCategoriesData, ListCategoriesError, ListCategoriesResponse, CreateCategoryData, CreateCategoryError, CreateCategoryResponse, FetchCategoryData, FetchCategoryError, FetchCategoryResponse, UpdateCategoryData, UpdateCategoryError, UpdateCategoryResponse, PartialUpdateCategoryData, PartialUpdateCategoryError, PartialUpdateCategoryResponse, DeleteCategoryData, DeleteCategoryError, DeleteCategoryResponse, ListPoiCategoriesData, ListPoiCategoriesError, ListPoiCategoriesResponse, ListPoiCategoriesByCategoryData, ListPoiCategoriesByCategoryError, ListPoiCategoriesByCategoryResponse, FetchCategoryForPoiCatData, FetchCategoryForPoiCatError, FetchCategoryForPoiCatResponse, ListLocationsData, ListLocationsError, ListLocationsResponse, CreateLocationData, CreateLocationError, CreateLocationResponse, FetchLocationData, FetchLocationError, FetchLocationResponse, UpdateLocationData, UpdateLocationError, UpdateLocationResponse, PartialUpdateLocationData, PartialUpdateLocationError, PartialUpdateLocationResponse, DeleteLocationData, DeleteLocationError, DeleteLocationResponse, FetchLocationRatingSummariesData, FetchLocationRatingSummariesError, FetchLocationRatingSummariesResponse, GetLocationReviewsData, GetLocationReviewsError, GetLocationReviewsResponse, ReverseGeocodeData, ReverseGeocodeError, ReverseGeocodeResponse, ForwardGeocodeData, ForwardGeocodeError, ForwardGeocodeResponse, ListReviewsData, ListReviewsError, ListReviewsResponse, CreateReviewData, CreateReviewError, CreateReviewResponse, FetchReviewData, FetchReviewError, FetchReviewResponse, UpdateReviewData, UpdateReviewError, UpdateReviewResponse, PartialUpdateReviewData, PartialUpdateReviewError, PartialUpdateReviewResponse, DeleteReviewData, DeleteReviewError, DeleteReviewResponse, VoteOnReviewData, VoteOnReviewError, VoteOnReviewResponse, GetUserReviewsData, GetUserReviewsError, GetUserReviewsResponse, ListUsersData, ListUsersError, ListUsersResponse, CreateUserData, CreateUserError, CreateUserResponse, FetchUserData, FetchUserError, FetchUserResponse, UpdateUserData, UpdateUserError, UpdateUserResponse, PartialUpdateUserData, PartialUpdateUserError, PartialUpdateUserResponse, DeleteUserData, DeleteUserError, DeleteUserResponse, GetAnonUserIdData, GetAnonUserIdError, GetAnonUserIdResponse, ListBarksForUserData, ListBarksForUserError, ListBarksForUserResponse, ListBarkConfigsForUserData, ListBarkConfigsForUserError, ListBarkConfigsForUserResponse, CreateUserBarkConfigData, CreateUserBarkConfigError, CreateUserBarkConfigResponse, FetchUserBarkConfigData, FetchUserBarkConfigError, FetchUserBarkConfigResponse, UpdateUserBarkConfigData, UpdateUserBarkConfigError, UpdateUserBarkConfigResponse, PartialUpdateUserBarkConfigData, PartialUpdateUserBarkConfigError, PartialUpdateUserBarkConfigResponse, DeleteUserBarkConfigData, DeleteUserBarkConfigError, DeleteUserBarkConfigResponse, SearchByCategoryOrKeywordData, SearchByCategoryOrKeywordError, SearchByCategoryOrKeywordResponse, FetchSearchData, FetchSearchError, FetchSearchResponse, SearchForOnlineOnlyData, SearchForOnlineOnlyError, SearchForOnlineOnlyResponse, SearchForCertifiedOnlyData, SearchForCertifiedOnlyError, SearchForCertifiedOnlyResponse, SearchForShaneRatedOnlyData, SearchForShaneRatedOnlyError, SearchForShaneRatedOnlyResponse, MapboxSuggestData, MapboxSuggestError, MapboxSuggestResponse, PreloadMapData, PreloadMapError, PreloadMapResponse, CreateRatingData, CreateRatingError, CreateRatingResponse, VerifyRecaptchaData, VerifyRecaptchaError, VerifyRecaptchaResponse, ListBarksError, ListBarksResponse, CreateBarkData, CreateBarkError, CreateBarkResponse, FetchBarkData, FetchBarkError, FetchBarkResponse, UpdateBarkData, UpdateBarkError, UpdateBarkResponse, PartialUpdateBarkData, PartialUpdateBarkError, PartialUpdateBarkResponse, DeleteBarkData, DeleteBarkError, DeleteBarkResponse, FetchCommunicationsForBarkData, FetchCommunicationsForBarkError, FetchCommunicationsForBarkResponse, FetchBarkCommunicationIdData, FetchBarkCommunicationIdError, FetchBarkCommunicationIdResponse, PartialUpdateCommunicationData, PartialUpdateCommunicationError, PartialUpdateCommunicationResponse, DeleteBarkCommunicationData, DeleteBarkCommunicationError, DeleteBarkCommunicationResponse, CreateBarkCommunicationLocationData, CreateBarkCommunicationLocationError, CreateBarkCommunicationLocationResponse, ListBarkCommunicationLocationsData, ListBarkCommunicationLocationsError, ListBarkCommunicationLocationsResponse, FetchBarkCommunicationUuidData, FetchBarkCommunicationUuidError, FetchBarkCommunicationUuidResponse, PartialUpdateCommunicationUuidData, PartialUpdateCommunicationUuidError, PartialUpdateCommunicationUuidResponse, DeleteBarkCommunicationUuidData, DeleteBarkCommunicationUuidError, DeleteBarkCommunicationUuidResponse, CreateBarkCommunicationLocationUuidData, CreateBarkCommunicationLocationUuidError, CreateBarkCommunicationLocationUuidResponse, ListBarkCommunicationLocationsUuidData, ListBarkCommunicationLocationsUuidError, ListBarkCommunicationLocationsUuidResponse, CreateListData, CreateListError, CreateListResponse, FetchListData, FetchListError, FetchListResponse, UpdateListData, UpdateListError, UpdateListResponse, PartialUpdateListData, PartialUpdateListError, PartialUpdateListResponse, DeleteListData, DeleteListError, DeleteListResponse, FetchListByUuidData, FetchListByUuidError, FetchListByUuidResponse, CreateListLocationData, CreateListLocationError, CreateListLocationResponse, UpdateListLocationData, UpdateListLocationError, UpdateListLocationResponse, DeleteListLocationData, DeleteListLocationError, DeleteListLocationResponse, CreateListUserData, CreateListUserError, CreateListUserResponse, UpdateListUserData, UpdateListUserError, UpdateListUserResponse, DeleteListUserData, DeleteListUserError, DeleteListUserResponse, FetchUserListsData, FetchUserListsError, FetchUserListsResponse, FaSendCodeData, FaSendCodeError, FaSendCodeResponse, FaCheckCodeData, FaCheckCodeError, FaCheckCodeResponse } from './types.gen';

export const client = createClient(createConfig());

/**
 * List Categories
 * Retrieve a list of Categories
 */
export const listCategories = <ThrowOnError extends boolean = false>(options?: Options<ListCategoriesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListCategoriesResponse, ListCategoriesError, ThrowOnError>({
        ...options,
        url: '/category'
    });
};

/**
 * Create Category
 * Create Category
 */
export const createCategory = <ThrowOnError extends boolean = false>(options: Options<CreateCategoryData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateCategoryResponse, CreateCategoryError, ThrowOnError>({
        ...options,
        url: '/category'
    });
};

/**
 * Fetch Category
 * Get a specific Category
 */
export const fetchCategory = <ThrowOnError extends boolean = false>(options: Options<FetchCategoryData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchCategoryResponse, FetchCategoryError, ThrowOnError>({
        ...options,
        url: '/category/{categoryId}'
    });
};

/**
 * Update Category
 * Update Category
 */
export const updateCategory = <ThrowOnError extends boolean = false>(options: Options<UpdateCategoryData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateCategoryResponse, UpdateCategoryError, ThrowOnError>({
        ...options,
        url: '/category/{categoryId}'
    });
};

/**
 * Partially Update Category
 * Partially Update Category
 */
export const partialUpdateCategory = <ThrowOnError extends boolean = false>(options: Options<PartialUpdateCategoryData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PartialUpdateCategoryResponse, PartialUpdateCategoryError, ThrowOnError>({
        ...options,
        url: '/category/{categoryId}'
    });
};

/**
 * Delete Category
 * Delete Category
 */
export const deleteCategory = <ThrowOnError extends boolean = false>(options: Options<DeleteCategoryData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteCategoryResponse, DeleteCategoryError, ThrowOnError>({
        ...options,
        url: '/category/{categoryId}'
    });
};

/**
 * List Poi Categories
 * Retrieve a list of PoiCategories
 */
export const listPoiCategories = <ThrowOnError extends boolean = false>(options?: Options<ListPoiCategoriesData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListPoiCategoriesResponse, ListPoiCategoriesError, ThrowOnError>({
        ...options,
        url: '/category/poi'
    });
};

/**
 * List Poi CategoryMapping for category
 * List Poi CategoryMapping for category
 */
export const listPoiCategoriesByCategory = <ThrowOnError extends boolean = false>(options?: Options<ListPoiCategoriesByCategoryData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListPoiCategoriesByCategoryResponse, ListPoiCategoriesByCategoryError, ThrowOnError>({
        ...options,
        url: '/category/poi/mapping'
    });
};

/**
 * Fetch Category for PoiCat
 * Get a specific Category for a poicat
 */
export const fetchCategoryForPoiCat = <ThrowOnError extends boolean = false>(options: Options<FetchCategoryForPoiCatData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchCategoryForPoiCatResponse, FetchCategoryForPoiCatError, ThrowOnError>({
        ...options,
        url: '/category/poi/mapping/{poiCatName}'
    });
};

/**
 * List Locations
 * Retrieve a list of Locations
 */
export const listLocations = <ThrowOnError extends boolean = false>(options?: Options<ListLocationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListLocationsResponse, ListLocationsError, ThrowOnError>({
        ...options,
        url: '/location'
    });
};

/**
 * Create Location
 * Create Location
 */
export const createLocation = <ThrowOnError extends boolean = false>(options: Options<CreateLocationData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateLocationResponse, CreateLocationError, ThrowOnError>({
        ...options,
        url: '/location'
    });
};

/**
 * Fetch Location
 * Get a specific Location
 */
export const fetchLocation = <ThrowOnError extends boolean = false>(options: Options<FetchLocationData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchLocationResponse, FetchLocationError, ThrowOnError>({
        ...options,
        url: '/location/{locationId}'
    });
};

/**
 * Update Location
 * Update Location
 */
export const updateLocation = <ThrowOnError extends boolean = false>(options: Options<UpdateLocationData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateLocationResponse, UpdateLocationError, ThrowOnError>({
        ...options,
        url: '/location/{locationId}'
    });
};

/**
 * Partially Update Location
 * Partially Update Location
 */
export const partialUpdateLocation = <ThrowOnError extends boolean = false>(options: Options<PartialUpdateLocationData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PartialUpdateLocationResponse, PartialUpdateLocationError, ThrowOnError>({
        ...options,
        url: '/location/{locationId}'
    });
};

/**
 * Delete Location
 * Delete Location
 */
export const deleteLocation = <ThrowOnError extends boolean = false>(options: Options<DeleteLocationData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteLocationResponse, DeleteLocationError, ThrowOnError>({
        ...options,
        url: '/location/{locationId}'
    });
};

/**
 * Fetch LocationRatingSummaries
 * Get summary ratings for a location
 */
export const fetchLocationRatingSummaries = <ThrowOnError extends boolean = false>(options: Options<FetchLocationRatingSummariesData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchLocationRatingSummariesResponse, FetchLocationRatingSummariesError, ThrowOnError>({
        ...options,
        url: '/location/{locationId}/rating'
    });
};

/**
 * Get LocationReviews
 * Get reviews for a location
 */
export const getLocationReviews = <ThrowOnError extends boolean = false>(options: Options<GetLocationReviewsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetLocationReviewsResponse, GetLocationReviewsError, ThrowOnError>({
        ...options,
        url: '/location/{locationId}/review'
    });
};

/**
 * Reverse geocode
 * Reverse geocode
 */
export const reverseGeocode = <ThrowOnError extends boolean = false>(options?: Options<ReverseGeocodeData, ThrowOnError>) => {
    return (options?.client ?? client).get<ReverseGeocodeResponse, ReverseGeocodeError, ThrowOnError>({
        ...options,
        url: '/geocode/reverse'
    });
};

/**
 * Forward geocode
 * Foward geocode
 */
export const forwardGeocode = <ThrowOnError extends boolean = false>(options?: Options<ForwardGeocodeData, ThrowOnError>) => {
    return (options?.client ?? client).get<ForwardGeocodeResponse, ForwardGeocodeError, ThrowOnError>({
        ...options,
        url: '/geocode/forward'
    });
};

/**
 * List Reviews
 * List reviews
 */
export const listReviews = <ThrowOnError extends boolean = false>(options?: Options<ListReviewsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListReviewsResponse, ListReviewsError, ThrowOnError>({
        ...options,
        url: '/review'
    });
};

/**
 * Create Review
 * Create Review
 */
export const createReview = <ThrowOnError extends boolean = false>(options: Options<CreateReviewData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateReviewResponse, CreateReviewError, ThrowOnError>({
        ...options,
        url: '/review'
    });
};

/**
 * Fetch Review
 * Get a specific Review
 */
export const fetchReview = <ThrowOnError extends boolean = false>(options: Options<FetchReviewData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchReviewResponse, FetchReviewError, ThrowOnError>({
        ...options,
        url: '/review/{reviewId}'
    });
};

/**
 * Update Review
 * Update Review
 */
export const updateReview = <ThrowOnError extends boolean = false>(options: Options<UpdateReviewData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateReviewResponse, UpdateReviewError, ThrowOnError>({
        ...options,
        url: '/review/{reviewId}'
    });
};

/**
 * Partially Update Review
 * Partially Update Review
 */
export const partialUpdateReview = <ThrowOnError extends boolean = false>(options: Options<PartialUpdateReviewData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PartialUpdateReviewResponse, PartialUpdateReviewError, ThrowOnError>({
        ...options,
        url: '/review/{reviewId}'
    });
};

/**
 * Delete Review
 * Delete Review
 */
export const deleteReview = <ThrowOnError extends boolean = false>(options: Options<DeleteReviewData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteReviewResponse, DeleteReviewError, ThrowOnError>({
        ...options,
        url: '/review/{reviewId}'
    });
};

/**
 * Vote on Review
 * Upvote or downvote a Review
 */
export const voteOnReview = <ThrowOnError extends boolean = false>(options: Options<VoteOnReviewData, ThrowOnError>) => {
    return (options?.client ?? client).get<VoteOnReviewResponse, VoteOnReviewError, ThrowOnError>({
        ...options,
        url: '/review/{reviewId}/vote'
    });
};

/**
 * Get UserReviews
 * Get reviews for a user
 */
export const getUserReviews = <ThrowOnError extends boolean = false>(options: Options<GetUserReviewsData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetUserReviewsResponse, GetUserReviewsError, ThrowOnError>({
        ...options,
        url: '/user/{userId}/review'
    });
};

/**
 * List Users
 * Retrieve a list of Users
 */
export const listUsers = <ThrowOnError extends boolean = false>(options?: Options<ListUsersData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListUsersResponse, ListUsersError, ThrowOnError>({
        ...options,
        url: '/user'
    });
};

/**
 * Create User
 * Create User
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateUserResponse, CreateUserError, ThrowOnError>({
        ...options,
        url: '/user'
    });
};

/**
 * Fetch User
 * Get a specific User
 */
export const fetchUser = <ThrowOnError extends boolean = false>(options: Options<FetchUserData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchUserResponse, FetchUserError, ThrowOnError>({
        ...options,
        url: '/user/{userId}'
    });
};

/**
 * Update User
 * Update User
 */
export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateUserResponse, UpdateUserError, ThrowOnError>({
        ...options,
        url: '/user/{userId}'
    });
};

/**
 * Partially Update User
 * Partially Update User
 */
export const partialUpdateUser = <ThrowOnError extends boolean = false>(options: Options<PartialUpdateUserData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PartialUpdateUserResponse, PartialUpdateUserError, ThrowOnError>({
        ...options,
        url: '/user/{userId}'
    });
};

/**
 * Delete User
 * Delete User
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteUserResponse, DeleteUserError, ThrowOnError>({
        ...options,
        url: '/user/{userId}'
    });
};

/**
 * Get Anon userId placeholder
 * Get Anon placeholder userId by profile
 */
export const getAnonUserId = <ThrowOnError extends boolean = false>(options?: Options<GetAnonUserIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<GetAnonUserIdResponse, GetAnonUserIdError, ThrowOnError>({
        ...options,
        url: '/user/anon'
    });
};

/**
 * List barks for user
 * Retrieve a list of barks for user
 */
export const listBarksForUser = <ThrowOnError extends boolean = false>(options: Options<ListBarksForUserData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListBarksForUserResponse, ListBarksForUserError, ThrowOnError>({
        ...options,
        url: '/user/{userId}/bark'
    });
};

/**
 * List barkconfigs for user
 * Retrieve a list of barkconfigs for user
 */
export const listBarkConfigsForUser = <ThrowOnError extends boolean = false>(options: Options<ListBarkConfigsForUserData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListBarkConfigsForUserResponse, ListBarkConfigsForUserError, ThrowOnError>({
        ...options,
        url: '/user/{userId}/barkconfig'
    });
};

/**
 * Create UserBarkConfig
 * Create UserBarkConfig
 */
export const createUserBarkConfig = <ThrowOnError extends boolean = false>(options: Options<CreateUserBarkConfigData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateUserBarkConfigResponse, CreateUserBarkConfigError, ThrowOnError>({
        ...options,
        url: '/user/{userId}/barkconfig'
    });
};

/**
 * Fetch UserBarkConfig
 * Get a specific UserBarkConfig
 */
export const fetchUserBarkConfig = <ThrowOnError extends boolean = false>(options: Options<FetchUserBarkConfigData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchUserBarkConfigResponse, FetchUserBarkConfigError, ThrowOnError>({
        ...options,
        url: '/user/{userId}/barkconfig/{userBarkConfigId}'
    });
};

/**
 * Update UserBarkConfig
 * Update UserBarkConfig
 */
export const updateUserBarkConfig = <ThrowOnError extends boolean = false>(options: Options<UpdateUserBarkConfigData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateUserBarkConfigResponse, UpdateUserBarkConfigError, ThrowOnError>({
        ...options,
        url: '/user/{userId}/barkconfig/{userBarkConfigId}'
    });
};

/**
 * Partially Update UserBarkConfig
 * Partially Update UserBarkConfig
 */
export const partialUpdateUserBarkConfig = <ThrowOnError extends boolean = false>(options: Options<PartialUpdateUserBarkConfigData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PartialUpdateUserBarkConfigResponse, PartialUpdateUserBarkConfigError, ThrowOnError>({
        ...options,
        url: '/user/{userId}/barkconfig/{userBarkConfigId}'
    });
};

/**
 * Delete UserBarkConfig
 * Delete UserBarkConfig
 */
export const deleteUserBarkConfig = <ThrowOnError extends boolean = false>(options: Options<DeleteUserBarkConfigData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteUserBarkConfigResponse, DeleteUserBarkConfigError, ThrowOnError>({
        ...options,
        url: '/user/{userId}/barkconfig/{userBarkConfigId}'
    });
};

/**
 * Search by Category or Keyword
 * Search by Category or Keyword
 */
export const searchByCategoryOrKeyword = <ThrowOnError extends boolean = false>(options?: Options<SearchByCategoryOrKeywordData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchByCategoryOrKeywordResponse, SearchByCategoryOrKeywordError, ThrowOnError>({
        ...options,
        url: '/search'
    });
};

/**
 * Fetch Search
 * Get a specific Search
 */
export const fetchSearch = <ThrowOnError extends boolean = false>(options: Options<FetchSearchData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchSearchResponse, FetchSearchError, ThrowOnError>({
        ...options,
        url: '/search/{searchId}'
    });
};

/**
 * Search for Online Only
 * Search for Online Only
 */
export const searchForOnlineOnly = <ThrowOnError extends boolean = false>(options?: Options<SearchForOnlineOnlyData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchForOnlineOnlyResponse, SearchForOnlineOnlyError, ThrowOnError>({
        ...options,
        url: '/search/online'
    });
};

/**
 * Search for Certified Only
 * Search for Certified Only
 */
export const searchForCertifiedOnly = <ThrowOnError extends boolean = false>(options?: Options<SearchForCertifiedOnlyData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchForCertifiedOnlyResponse, SearchForCertifiedOnlyError, ThrowOnError>({
        ...options,
        url: '/search/certified'
    });
};

/**
 * Search for Shane-rated Only
 * Search for Shane-rated Only
 */
export const searchForShaneRatedOnly = <ThrowOnError extends boolean = false>(options?: Options<SearchForShaneRatedOnlyData, ThrowOnError>) => {
    return (options?.client ?? client).get<SearchForShaneRatedOnlyResponse, SearchForShaneRatedOnlyError, ThrowOnError>({
        ...options,
        url: '/search/shane'
    });
};

/**
 * Mapbox location search by keyword
 * Mapbox location search by keyword
 */
export const mapboxSuggest = <ThrowOnError extends boolean = false>(options?: Options<MapboxSuggestData, ThrowOnError>) => {
    return (options?.client ?? client).get<MapboxSuggestResponse, MapboxSuggestError, ThrowOnError>({
        ...options,
        url: '/search/suggest'
    });
};

/**
 * Preload map results
 * Preload map results
 */
export const preloadMap = <ThrowOnError extends boolean = false>(options: Options<PreloadMapData, ThrowOnError>) => {
    return (options?.client ?? client).get<PreloadMapResponse, PreloadMapError, ThrowOnError>({
        ...options,
        url: '/search/preload'
    });
};

/**
 * Create Rating
 * Create Rating
 */
export const createRating = <ThrowOnError extends boolean = false>(options: Options<CreateRatingData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateRatingResponse, CreateRatingError, ThrowOnError>({
        ...options,
        url: '/rating'
    });
};

/**
 * Verify recaptcha
 * Verify recaptcha challenge
 */
export const verifyRecaptcha = <ThrowOnError extends boolean = false>(options?: Options<VerifyRecaptchaData, ThrowOnError>) => {
    return (options?.client ?? client).get<VerifyRecaptchaResponse, VerifyRecaptchaError, ThrowOnError>({
        ...options,
        url: '/recaptcha'
    });
};

/**
 * List barks
 * Retrieve a list of barks
 */
export const listBarks = <ThrowOnError extends boolean = false>(options?: Options<unknown, ThrowOnError>) => {
    return (options?.client ?? client).get<ListBarksResponse, ListBarksError, ThrowOnError>({
        ...options,
        url: '/bark'
    });
};

/**
 * Create Bark
 * Create Bark
 */
export const createBark = <ThrowOnError extends boolean = false>(options: Options<CreateBarkData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateBarkResponse, CreateBarkError, ThrowOnError>({
        ...options,
        url: '/bark'
    });
};

/**
 * Fetch Bark
 * Get a specific Bark
 */
export const fetchBark = <ThrowOnError extends boolean = false>(options: Options<FetchBarkData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchBarkResponse, FetchBarkError, ThrowOnError>({
        ...options,
        url: '/bark/{barkId}'
    });
};

/**
 * Update Bark
 * Update Bark
 */
export const updateBark = <ThrowOnError extends boolean = false>(options: Options<UpdateBarkData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateBarkResponse, UpdateBarkError, ThrowOnError>({
        ...options,
        url: '/bark/{barkId}'
    });
};

/**
 * Partially Update Bark
 * Partially Update Bark
 */
export const partialUpdateBark = <ThrowOnError extends boolean = false>(options: Options<PartialUpdateBarkData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PartialUpdateBarkResponse, PartialUpdateBarkError, ThrowOnError>({
        ...options,
        url: '/bark/{barkId}'
    });
};

/**
 * Delete Bark
 * Delete Bark
 */
export const deleteBark = <ThrowOnError extends boolean = false>(options: Options<DeleteBarkData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteBarkResponse, DeleteBarkError, ThrowOnError>({
        ...options,
        url: '/bark/{barkId}'
    });
};

/**
 * Fetch Communications for Bark
 * Fetch Communications for Bark
 */
export const fetchCommunicationsForBark = <ThrowOnError extends boolean = false>(options: Options<FetchCommunicationsForBarkData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchCommunicationsForBarkResponse, FetchCommunicationsForBarkError, ThrowOnError>({
        ...options,
        url: '/bark/{barkId}/communication'
    });
};

/**
 * Fetch Bark Communication
 * Get a specific BarkCommunication
 */
export const fetchBarkCommunicationId = <ThrowOnError extends boolean = false>(options: Options<FetchBarkCommunicationIdData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchBarkCommunicationIdResponse, FetchBarkCommunicationIdError, ThrowOnError>({
        ...options,
        url: '/communication/{barkCommunicationId}'
    });
};

/**
 * Partially Update Communication
 * Partially Update Communication
 */
export const partialUpdateCommunication = <ThrowOnError extends boolean = false>(options: Options<PartialUpdateCommunicationData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PartialUpdateCommunicationResponse, PartialUpdateCommunicationError, ThrowOnError>({
        ...options,
        url: '/communication/{barkCommunicationId}'
    });
};

/**
 * Delete Bark Communication
 * Delete Bark Communication
 */
export const deleteBarkCommunication = <ThrowOnError extends boolean = false>(options: Options<DeleteBarkCommunicationData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteBarkCommunicationResponse, DeleteBarkCommunicationError, ThrowOnError>({
        ...options,
        url: '/communication/{barkCommunicationId}'
    });
};

/**
 * Create BarkCommunicationLocation
 * Create BarkCommunicationLocation
 */
export const createBarkCommunicationLocation = <ThrowOnError extends boolean = false>(options: Options<CreateBarkCommunicationLocationData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateBarkCommunicationLocationResponse, CreateBarkCommunicationLocationError, ThrowOnError>({
        ...options,
        url: '/communication/{barkCommunicationId}/location'
    });
};

/**
 * List bark communication locations
 * Retrieve a list of bark communication locations
 */
export const listBarkCommunicationLocations = <ThrowOnError extends boolean = false>(options: Options<ListBarkCommunicationLocationsData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListBarkCommunicationLocationsResponse, ListBarkCommunicationLocationsError, ThrowOnError>({
        ...options,
        url: '/communication/{barkCommunicationId}/location'
    });
};

/**
 * Fetch Bark Communication
 * Get a specific BarkCommunication
 */
export const fetchBarkCommunicationUuid = <ThrowOnError extends boolean = false>(options: Options<FetchBarkCommunicationUuidData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchBarkCommunicationUuidResponse, FetchBarkCommunicationUuidError, ThrowOnError>({
        ...options,
        url: '/communication/{uuid}'
    });
};

/**
 * Partially Update Communication
 * Partially Update Communication
 */
export const partialUpdateCommunicationUuid = <ThrowOnError extends boolean = false>(options: Options<PartialUpdateCommunicationUuidData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PartialUpdateCommunicationUuidResponse, PartialUpdateCommunicationUuidError, ThrowOnError>({
        ...options,
        url: '/communication/{uuid}'
    });
};

/**
 * Delete Bark Communication
 * Delete Bark Communication
 */
export const deleteBarkCommunicationUuid = <ThrowOnError extends boolean = false>(options: Options<DeleteBarkCommunicationUuidData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteBarkCommunicationUuidResponse, DeleteBarkCommunicationUuidError, ThrowOnError>({
        ...options,
        url: '/communication/{uuid}'
    });
};

/**
 * Create BarkCommunicationLocation UUID
 * Create BarkCommunicationLocation UUID
 */
export const createBarkCommunicationLocationUuid = <ThrowOnError extends boolean = false>(options: Options<CreateBarkCommunicationLocationUuidData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateBarkCommunicationLocationUuidResponse, CreateBarkCommunicationLocationUuidError, ThrowOnError>({
        ...options,
        url: '/communication/{uuid}/location'
    });
};

/**
 * List bark communication locations UUID
 * Retrieve a list of bark communication locations UUID
 */
export const listBarkCommunicationLocationsUuid = <ThrowOnError extends boolean = false>(options: Options<ListBarkCommunicationLocationsUuidData, ThrowOnError>) => {
    return (options?.client ?? client).get<ListBarkCommunicationLocationsUuidResponse, ListBarkCommunicationLocationsUuidError, ThrowOnError>({
        ...options,
        url: '/communication/{uuid}/location'
    });
};

/**
 * Create List
 * Create List
 */
export const createList = <ThrowOnError extends boolean = false>(options: Options<CreateListData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateListResponse, CreateListError, ThrowOnError>({
        ...options,
        url: '/list'
    });
};

/**
 * Fetch List
 * Get a specific List
 */
export const fetchList = <ThrowOnError extends boolean = false>(options: Options<FetchListData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchListResponse, FetchListError, ThrowOnError>({
        ...options,
        url: '/list/{listId}'
    });
};

/**
 * Update List
 * Update List
 */
export const updateList = <ThrowOnError extends boolean = false>(options: Options<UpdateListData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateListResponse, UpdateListError, ThrowOnError>({
        ...options,
        url: '/list/{listId}'
    });
};

/**
 * Partially Update List
 * Partially Update List
 */
export const partialUpdateList = <ThrowOnError extends boolean = false>(options: Options<PartialUpdateListData, ThrowOnError>) => {
    return (options?.client ?? client).patch<PartialUpdateListResponse, PartialUpdateListError, ThrowOnError>({
        ...options,
        url: '/list/{listId}'
    });
};

/**
 * Delete List
 * Delete List
 */
export const deleteList = <ThrowOnError extends boolean = false>(options: Options<DeleteListData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteListResponse, DeleteListError, ThrowOnError>({
        ...options,
        url: '/list/{listId}'
    });
};

/**
 * Fetch List by UUID
 * Get a specific List by UUID
 */
export const fetchListByUuid = <ThrowOnError extends boolean = false>(options: Options<FetchListByUuidData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchListByUuidResponse, FetchListByUuidError, ThrowOnError>({
        ...options,
        url: '/list/uuid/{listUuid}'
    });
};

/**
 * Create ListLocation
 * Create ListLocation
 */
export const createListLocation = <ThrowOnError extends boolean = false>(options: Options<CreateListLocationData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateListLocationResponse, CreateListLocationError, ThrowOnError>({
        ...options,
        url: '/list/{listId}/location'
    });
};

/**
 * Update ListLocation
 * Update ListLocation
 */
export const updateListLocation = <ThrowOnError extends boolean = false>(options: Options<UpdateListLocationData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateListLocationResponse, UpdateListLocationError, ThrowOnError>({
        ...options,
        url: '/list/{listId}/location/{listLocationId}'
    });
};

/**
 * Delete ListLocation
 * Delete ListLocation
 */
export const deleteListLocation = <ThrowOnError extends boolean = false>(options: Options<DeleteListLocationData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteListLocationResponse, DeleteListLocationError, ThrowOnError>({
        ...options,
        url: '/list/{listId}/location/{listLocationId}'
    });
};

/**
 * Create ListUser
 * Create ListUser
 */
export const createListUser = <ThrowOnError extends boolean = false>(options: Options<CreateListUserData, ThrowOnError>) => {
    return (options?.client ?? client).post<CreateListUserResponse, CreateListUserError, ThrowOnError>({
        ...options,
        url: '/list/{listId}/user'
    });
};

/**
 * Update ListUser
 * Update ListUser
 */
export const updateListUser = <ThrowOnError extends boolean = false>(options: Options<UpdateListUserData, ThrowOnError>) => {
    return (options?.client ?? client).put<UpdateListUserResponse, UpdateListUserError, ThrowOnError>({
        ...options,
        url: '/list/{listId}/user/{userId}'
    });
};

/**
 * Delete ListUser
 * Delete ListUser
 */
export const deleteListUser = <ThrowOnError extends boolean = false>(options: Options<DeleteListUserData, ThrowOnError>) => {
    return (options?.client ?? client).delete<DeleteListUserResponse, DeleteListUserError, ThrowOnError>({
        ...options,
        url: '/list/{listId}/user/{userId}'
    });
};

/**
 * Fetch Lists
 * Get Lists for a user
 */
export const fetchUserLists = <ThrowOnError extends boolean = false>(options: Options<FetchUserListsData, ThrowOnError>) => {
    return (options?.client ?? client).get<FetchUserListsResponse, FetchUserListsError, ThrowOnError>({
        ...options,
        url: '/user/{userId}/list'
    });
};

/**
 * 2FA send code
 * 2FA send code"
 */
export const faSendCode = <ThrowOnError extends boolean = false>(options?: Options<FaSendCodeData, ThrowOnError>) => {
    return (options?.client ?? client).get<FaSendCodeResponse, FaSendCodeError, ThrowOnError>({
        ...options,
        url: '/verify/send'
    });
};

/**
 * 2FA check code
 * 2FA check code"
 */
export const faCheckCode = <ThrowOnError extends boolean = false>(options: Options<FaCheckCodeData, ThrowOnError>) => {
    return (options?.client ?? client).get<FaCheckCodeResponse, FaCheckCodeError, ThrowOnError>({
        ...options,
        url: '/verify/check'
    });
};